import Container from "@material-ui/core/Container";
import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@material-ui/pickers";
import ReactHookFormRadio from "../../../components/common/form/ReactHookFormRadio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { clientSchema } from "./schema/client";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  buttonAdd: {
    marginLeft: theme.spacing(1),
  },
}));

const Edit = (props) => {
  const classes = useStyles();
  const {
    isEnabledFormEditClient,
    editHandler,
    loading,
    show,
    currentClient,
    translateValidation,
  } = props;
  const { register, handleSubmit, errors, reset, control } = useForm({
    resolver: yupResolver(clientSchema(translateValidation)),
  });

  const [inputState, setInputState] = useState({
    name: currentClient?.name,
    email: currentClient?.email,
    cnpj: currentClient?.cnpjClient,
    fantasyName: currentClient?.nameFantasyClient,
    contractorName: currentClient?.contractorName,
    contractType: currentClient?.contractType,
  });

  const initialExpireContractDate =
    currentClient?.dateContractValidity.split("/");

  const [expireContract, setExpireContract] = useState(new Date());

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevVisibility = usePrevious(currentClient);

  useEffect(() => {
    if (prevVisibility !== currentClient) {
      const newState = {
        ...inputState,
        name: currentClient?.name,
        email: currentClient?.email,
        cnpj: currentClient?.cnpjClient,
        fantasyName: currentClient?.nameFantasyClient,
        contractorName: currentClient?.contractorName,
        contractType: currentClient?.contractType,
      };
      setInputState(newState);

      const date =
        initialExpireContractDate[0] +
        initialExpireContractDate[1] +
        initialExpireContractDate[2];

      setExpireContract(moment(date, "DDMMYYYY"));
    }
  }, [currentClient, initialExpireContractDate, inputState, prevVisibility]);

  const onsubmit = (data) => {
    reset();
    editHandler(data);
  };

  const handleCancel = () => {
    reset();
    show();
  };

  const handleChangeInput = (event) => {
    setInputState({
      ...inputState,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Box component="span" display={isEnabledFormEditClient ? "none" : "block"}>
      <Paper elevation={1}>
        <Container maxWidth={false} className={classes.container}>
          <Typography
            className={classes.title}
            variant="h5"
            component="h1"
            gutterBottom
          >
            {translateValidation.title}
          </Typography>

          <form fullWidth onSubmit={handleSubmit(onsubmit)} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.name && true}
                  helperText={errors.name && errors.name.message}
                  id="name"
                  name="name"
                  label={translateValidation.name.label}
                  value={inputState.name}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.name.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.email && true}
                  helperText={errors.email && errors.email.message}
                  id="email"
                  name="email"
                  label={translateValidation.email.label}
                  value={inputState.email}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.email.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.fantasyName && true}
                  helperText={errors.fantasyName && errors.fantasyName.message}
                  id="fantasyName"
                  name="fantasyName"
                  value={inputState.fantasyName}
                  onChange={handleChangeInput}
                  label={translateValidation.fantasyName.label}
                  placeholder={translateValidation.fantasyName.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.cnpj && true}
                  helperText={errors.cnpj && errors.cnpj.message}
                  id="cnpj"
                  name="cnpj"
                  label={translateValidation.cnpj.label}
                  value={inputState.cnpj}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.cnpj.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <DatePicker
                  inputRef={register}
                  id="expireContract"
                  name="expireContract"
                  views={["year", "month", "date"]}
                  label={translateValidation.expireContract.label}
                  helperText={
                    errors.expireContract &&
                    translateValidation.expireContract.label.requiredErrorMsg
                  }
                  disablePast
                  openTo="year"
                  animateYearScrolling
                  format="DD/MM/YYYY"
                  value={expireContract}
                  onChange={setExpireContract}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={4}>
                <ReactHookFormRadio
                  inputRef={register}
                  control={control}
                  error={errors.contractType && true}
                  helperText={
                    errors.contractType && errors.contractType.message
                  }
                  id="contractType"
                  name="contractType"
                  label={translateValidation.contractType.label}
                  style={{ width: "100%" }}
                  defaultValue={inputState?.contractType}
                >
                  <FormControlLabel
                    value="P1 - Plano MENSAL Pro (B2B XPAR)"
                    control={<Radio />}
                    label="P1 - Plano MENSAL Pro (B2B XPAR)"
                  />
                  <FormControlLabel
                    value="P2 - Plano SEMESTRAL (B2B XPAR)"
                    control={<Radio />}
                    label="P2 - Plano SEMESTRAL (B2B XPAR)"
                  />
                  <FormControlLabel
                    value="P3 - Plano ANUAL Pro (B2B XPAR)"
                    control={<Radio />}
                    label="P3 - Plano ANUAL Pro (B2B XPAR)"
                  />
                </ReactHookFormRadio>
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <div className={classes.buttons}>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={loading}
                    onClick={() => handleCancel()}
                  >
                    {translateValidation.cancelButton}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.buttonAdd}
                    disabled={loading}
                  >
                    {translateValidation.confirmButton}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>
    </Box>
  );
};

Edit.propTypes = {
  isEnabledFormEditClient: PropTypes.bool.isRequired,
  editHandler: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  show: PropTypes.func.isRequired,
  currentClient: PropTypes.object.isRequired,
};

export default Edit;
